// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: #eee;
  position: sticky;
  top: 0; /* Ensures navbar sticks to the top */
  z-index: 1000; /* Keeps navbar above other content */
}

/* Style adjustments for both links and buttons */
.navbar a, .navbar button.link-button {
  text-decoration: none;
  color: #333;
  display: flex;
  align-items: center;
  background: none; /* Specific to buttons */
  border: none; /* Specific to buttons */
  cursor: pointer; /* Specific to buttons */
  font: inherit; /* Specific to buttons */
  padding: 0; /* Specific to buttons */
}

/* Retain the existing download button styles and apply to both a and button */
.navbar a.download-btn, .navbar button.download-btn {
  background-color: #ea1e0f; /* Red background */
  padding: 8px 15px;
  border-radius: 5px;
  color: white; /* White text */
}

.navbar a.download-btn:hover, .navbar button.download-btn:hover {
  background-color: #45a049; /* Darker green on hover */
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    align-items: center;
  }

  /* Ensure buttons and links look good in responsive layout */
  .navbar a, .navbar button.link-button {
    margin-bottom: 10px; /* Add spacing for stacked items on smaller screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM,EAAE,qCAAqC;EAC7C,aAAa,EAAE,qCAAqC;AACtD;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB,EAAE,wBAAwB;EAC1C,YAAY,EAAE,wBAAwB;EACtC,eAAe,EAAE,wBAAwB;EACzC,aAAa,EAAE,wBAAwB;EACvC,UAAU,EAAE,wBAAwB;AACtC;;AAEA,8EAA8E;AAC9E;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,4DAA4D;EAC5D;IACE,mBAAmB,EAAE,qDAAqD;EAC5E;AACF","sourcesContent":[".navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  background-color: #eee;\r\n  position: sticky;\r\n  top: 0; /* Ensures navbar sticks to the top */\r\n  z-index: 1000; /* Keeps navbar above other content */\r\n}\r\n\r\n/* Style adjustments for both links and buttons */\r\n.navbar a, .navbar button.link-button {\r\n  text-decoration: none;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  background: none; /* Specific to buttons */\r\n  border: none; /* Specific to buttons */\r\n  cursor: pointer; /* Specific to buttons */\r\n  font: inherit; /* Specific to buttons */\r\n  padding: 0; /* Specific to buttons */\r\n}\r\n\r\n/* Retain the existing download button styles and apply to both a and button */\r\n.navbar a.download-btn, .navbar button.download-btn {\r\n  background-color: #ea1e0f; /* Red background */\r\n  padding: 8px 15px;\r\n  border-radius: 5px;\r\n  color: white; /* White text */\r\n}\r\n\r\n.navbar a.download-btn:hover, .navbar button.download-btn:hover {\r\n  background-color: #45a049; /* Darker green on hover */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .navbar {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  /* Ensure buttons and links look good in responsive layout */\r\n  .navbar a, .navbar button.link-button {\r\n    margin-bottom: 10px; /* Add spacing for stacked items on smaller screens */\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
